import { IconUpload } from '@consta/icons/IconUpload'
import type { DataAnalyticsId } from '@core/core/types'
import {
  IconGeoBD,
  IconGeoDomain,
  IconGeoMap,
  IconGeoML2,
  IconGeoObjSeismdataVerts,
  IconGeoSpeed,
  IconMapFetching,
} from '@core/icons'

import type { RibbonItem } from '../../types'
import { RibbonItemsText } from '../../types'

export const defaultItems: (RibbonItem & DataAnalyticsId)[] = [
  {
    text: RibbonItemsText.fileUpload,
    icon: IconUpload,
    margin: true,
    dataAnalyticsId: 'import_click',
  },
  {
    text: RibbonItemsText.database,
    icon: IconGeoBD,
    dataAnalyticsId: 'hot storage_click',
  },
]
export const seismicInterpretationItems: RibbonItem[] = [
  {
    text: RibbonItemsText.mapping,
    icon: IconGeoMap,
    delimiter: true,
    margin: true,
  },
  {
    text: RibbonItemsText.machineLearning,
    icon: IconGeoML2,
    margin: true,
  },
  {
    text: RibbonItemsText.mapFetching,
    icon: IconMapFetching,
    margin: true,
  },
  { text: RibbonItemsText.velocitySimulation, icon: IconGeoSpeed, delimiter: true, margin: true },
  { text: RibbonItemsText.applyVelocityModel, icon: IconGeoDomain, margin: true },
  { text: RibbonItemsText.speedLaws, icon: IconGeoObjSeismdataVerts },
]
